function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.399 3.347V1.481m4.385 1.866l.023-1.89M5.591 2.882v-1.4m6.625 1.866l-.023-1.89M10 2.858v-1.4m6.602 1.89V1.481m-2.193 1.4v-1.4M1.206 6.52V1.48h17.588v5.04H1.206z",
  stroke: "currentColor",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));